import React from 'react';
import { Alert } from '@1c/ui';
import styles from './styles.module.scss';

const SberAlert = () => (
  <Alert level="danger" className={styles['alert']}>
    <p>Для приема оплаты через Сбербанк в 1С:СБП необходимо подписать заявления в Сбербизнес:</p>
    <ul>
      <li>Регистрация дополнительной торгово-сервисной точки</li>
      <li>Подключить приём платежей по QR от агента ТСП</li>
    </ul>
    Если хотя бы одно из заявлений не будет подписано, банк будет отклонять платежи.
    <br />
    <a href="/SBP_agent_Sber_instruction.docx" download>
      Инструкция по подключению
    </a>{' '}
    СБП в Сбербизнес.
  </Alert>
);

export default SberAlert;
